/* eslint-disable indent */
import { Dispatch, ReducerAction } from 'react';
import { actions } from '.';
import { IBillingMethods, PlanCode } from '../../../../interfaces';

const handleFieldChange = (
  dispatch: Dispatch<ReducerAction<any>>,
  payload: { name: string; value: any }
) => {
  dispatch({ type: actions.UPDATE_FIELD, payload });
};

const setCountry = (dispatch: Dispatch<ReducerAction<any>>, payload: { value: string }) => {
  dispatch({ type: actions.SET_COUNTRY, payload });
};

const setPlan = (dispatch: Dispatch<ReducerAction<any>>, payload: PlanCode) => {
  dispatch({ type: actions.SET_PLANCODE, payload });
};

const setLoading = (dispatch: Dispatch<ReducerAction<any>>, payload: boolean) => {
  dispatch({ type: actions.SET_LOADING, payload });
};

const setBillingMethod = (
  dispatch: Dispatch<ReducerAction<any>>,
  billingOption: IBillingMethods
) => {
  dispatch({ type: actions.SET_BILLING_METHOD, payload: billingOption });
};

const setTotal = (dispatch: Dispatch<ReducerAction<any>>, total: number) => {
  dispatch({ type: actions.SET_TOTAL, payload: total });
};

const handleCaptchaExpired = (dispatch: Dispatch<ReducerAction<any>>) => {
  dispatch({ type: actions.ON_CAPTCHA_EXPIRED });
};

const handleCaptchaError = (dispatch: Dispatch<ReducerAction<any>>, error: any) => {
  dispatch({ type: actions.ON_CAPTCHA_ERROR, payload: error });
};

const handleRecurlyTokenError = (dispatch: Dispatch<ReducerAction<any>>, error: string) => {
  dispatch({ type: actions.ON_RECURLY_TOKEN_ERROR, payload: error });
};

const setAcceptedTerms = (dispatch: Dispatch<ReducerAction<any>>, payload: boolean) => {
  dispatch({ type: actions.SET_ACCEPTED_TERMS, payload });
};

const handleFormError = (
  dispatch: Dispatch<ReducerAction<any>>,
  payload: { msg: string; errorCode?: string }
) => {
  dispatch({ type: actions.ON_FORM_ERROR, payload });
};

export {
  setAcceptedTerms,
  handleCaptchaError,
  handleCaptchaExpired,
  handleFieldChange,
  handleRecurlyTokenError,
  setBillingMethod,
  setCountry,
  setLoading,
  setPlan,
  setTotal,
  handleFormError,
};
